export const INSTANCE_TOKEN = 'sasp_firebase_token';
export const IOS_TOKEN = 'sasp_firebase_apns_token';
export const VAPIDKEY = "BD2B8BMgFLOVCqksa3HWpRoVQt1Ymijvc9myxDAoCKasRWcrnvGFPdjug7Wkbfp42VKYcG_Dh7O1tUdnoB9z-yk";

export const FIREBASE_WEB_CONFIG = {
    apiKey: "AIzaSyDfnvS7fSuz9Ug2JW0MShW7vYofb_BECn8",
    authDomain: "sasp-mobile-and-web-app.firebaseapp.com",
    databaseURL: "https://sasp-mobile-and-web-app.firebaseio.com",
    projectId: "sasp-mobile-and-web-app",
    storageBucket: "sasp-mobile-and-web-app.appspot.com",
    messagingSenderId: "8788043734",
    appId: "1:8788043734:web:70eb2f227db23e9d1a6677",
    measurementId: "G-610CVBXCQM"
};

export const FIREBASE_ANDROID_CONFIG = {
    apiKey: "AIzaSyDfnvS7fSuz9Ug2JW0MShW7vYofb_BECn8",
    authDomain: "sasp-mobile-and-web-app.firebaseapp.com",
    databaseURL: "https://sasp-mobile-and-web-app.firebaseio.com",
    projectId: "sasp-mobile-and-web-app",
    storageBucket: "sasp-mobile-and-web-app.appspot.com",
    messagingSenderId: "8788043734",
    appId: "1:8788043734:web:70eb2f227db23e9d1a6677",
    measurementId: "G-610CVBXCQM"
};

export const FIREBASE_IOS_CONFIG = {
    apiKey: "AIzaSyDfnvS7fSuz9Ug2JW0MShW7vYofb_BECn8",
    authDomain: "sasp-mobile-and-web-app.firebaseapp.com",
    databaseURL: "https://sasp-mobile-and-web-app.firebaseio.com",
    projectId: "sasp-mobile-and-web-app",
    storageBucket: "sasp-mobile-and-web-app.appspot.com",
    messagingSenderId: "8788043734",
    appId: "1:8788043734:web:70eb2f227db23e9d1a6677",
    measurementId: "G-610CVBXCQM"
};

export const REFSMATS = {
    '2021': '',
}

export const testerArr = [
    '00863273'
]
 
export const APPVERSION = '1.23.008';
export const APPID = 'org.auanet.auau.sasp';

export const DATE = new Date();

export const APPYEAR = () => {
    let _d = DATE;
    return _d.getFullYear();
}

export const OASIS_DATE = () => {
    return new Date(2025, 0, 4);
}

export const APPDAY = () => {
    Date.prototype.isLeapYear = function() {
        var year = this.getFullYear();
        if((year & 3) != 0) return false;
        return ((year % 100) != 0 || (year % 400) == 0);
    };
    
    // Get Day of Year
    Date.prototype.getDOY = function() {
        var dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        var mn = this.getMonth();
        var dn = this.getDate();
        var dayOfYear = dayCount[mn] + dn;
        if(mn > 1 && this.isLeapYear()) dayOfYear++;
        return dayOfYear;
    };

    return DATE.getDOY();
}

export const QUIZ_INSTANCE = () => {
    const date = new Date();
    const epoch = date.getTime();
    const token = epoch.toString(16);

    return token;
}

export const LOADIGNARRAY = [
    'Connecting...',
    'Verifying Access...',
    'Accessing Data...',
    'Loading Data...',
]

export const HOME_TEXT_ARRAY = [
    'Connecting to AUA Servers.',
    'The American Urological Association designates this enduring material for a maximum of 20.00 <em>AMA PRA Category 1 Credits&trade;</em>. ',
    'Loading SASP App Profile data.',
    'To earn credit, participants must designate answers for each of the 150 multiple-choice questions, answering at least 50% of the test questions correctly, complete the evaluation, and claim CME.',
    'Gathering SASP Subscriptions.',
    'October is the busiest month, with an average of 300 thousand SASP questions answered.',
    'Downloading Custom Decks.',
    'Since SASP App was released in 2021 almost 6 million questions have be answered. ',
    'Downloading Decks by Topic Area.',
    "SASP Mobile app users can make their own Custom Study Decks from the user's total question pool.",
    'Generating CME Tests.',
    'An SASP Mobile app users total question pool is generated by combining all of the SASP subscription that user owns. The more SASP years, the more questions one has to study from.',
    'Preparing to load application.',
    'CME Credits expire after three years of original release date. Answers must be submitted by the CME credits expiration deadline to receive credit for that year.',
    'Your application will be ready soon...',
    'Your application will be ready soon...',
    'Your application will be ready soon...',
    'Your application will be ready soon...',
    'Your application will be ready soon...',
    'Your application will be ready soon...',
]

export const DATA_LONG_LOAD = [
    'Connecting to AUA Servers.',
    'To earn credit, participants must designate answers for each of the 150 multiple-choice questions, answering at least 50% of the test questions correctly, complete the evaluation, and claim CME.',
    'This may take awhile as we calculate your score.',
    'CME Credits expire after three years of original release date. Answers must be submitted by the CME credits expiration deadline to receive credit for that year.',
    'Please be patient as we compile your answers.'
]

export const DATA_TEXT_ARRAY = [
    'More than 1.5 million SASP questions were answered in 2023.',
    'AUA Pre-built Study Decks where introduced in the 4th Quarter 2022.',
    'October is the busiest month, with an average of 300 thousand SASP questions answered.',
    'More than 1.5 million SASP questions were answered in 2025.',
    'The American Urological Association designates this enduring material for a maximum of 20.00 <em>AMA PRA Category 1 Credits&trade;</em>. ',
    'More than 1.3 million SASP questions were answered in 2022.',
    'Physicians should claim only the credit commensurate with the extent of their participation in the activity.',
    'CME Credits expire after three years of original release date. Answers must be submitted by the CME credits expiration deadline to receive credit for that year.',
    'More than 1.2 million SASP questions were answered in 2021.',
    'To earn credit, participants must designate answers for each of the 150 multiple-choice questions, answering at least 50% of the test questions correctly, complete the evaluation, and claim CME.',
    'More than 1.5 million SASP questions were answered in 2024.',
    'New SASP years and questions are available in the AUA SASP Mobile App on the 1st of January each year.',
    'Since SASP App was released in 2021 almost 6 million questions have be answered. ',
    'The SASP App has two modes: A CME Test mode and a Non-CME Study mode.',
    'The busiest month in the SASP of all time was July 2024 with 341,420 questions answered.',
    'There are three main types of decks: Custom Study Decks, Prebuilt Decks, and Flashcards.',
    'SASP Mobile app users can share their decks with others.',
    "SASP Mobile app users can make their own Custom Study Decks from the user's total question pool.",
    'An SASP Mobile app users total question pool is generated by combining all of the SASP subscription that user owns. The more SASP years, the more questions one has to study from.',
    'Residency Programs can create and share decks with their residents.'
];

export const OVERLOAD_DATA = [
    {mcid: '00863273', key: '04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153', questionID: 8289, gamemode: 1, optionSelected: 41441}, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.015"
        }
    },
    {mcid: '00863273', key: '04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153', questionID: 8289, gamemode: 2, optionSelected: 41441}, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8608,
        gamemode: 3,
        optionSelected: 43039,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8553,
        gamemode: 2,
        optionSelected: 42765,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8549,
        gamemode: 2,
        optionSelected: 42743,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    },
    {mcid: '00863273', key: '04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153', questionID: 8290, gamemode: 1, optionSelected: 41448}, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8550,
        gamemode: 2,
        optionSelected: 42750,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    },
    {mcid: '00863273', key: '04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153', questionID: 8290, gamemode: 2, optionSelected: 41448},
    {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8551,
        gamemode: 2,
        optionSelected: 42753,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    },
    {mcid: '00863273', key: '04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153', questionID: 8291, gamemode: 1, optionSelected: 41453}, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8552,
        gamemode: 2,
        optionSelected: 42759,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    },
    {mcid: '00863273', key: '04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153', questionID: 8291, gamemode: 2, optionSelected: 41453}, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8553,
        gamemode: 2,
        optionSelected: 42765,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8554,
        gamemode: 2,
        optionSelected: 42767,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8554,
        gamemode: 2,
        optionSelected: 42767,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8555,
        gamemode: 2,
        optionSelected: 42775,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8292,
        gamemode: 2,
        optionSelected: 41460,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8556,
        gamemode: 2,
        optionSelected: 42779,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 7727,
        gamemode: 6,
        optionSelected: 38635,
        deckID: 0
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8557,
        gamemode: 2,
        optionSelected: 42785,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8305,
        gamemode: 7,
        optionSelected: 41523,
        deckID: 11110,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8558,
        gamemode: 2,
        optionSelected: 42786,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8559,
        gamemode: 2,
        optionSelected: 42793,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8292,
        gamemode: 1,
        optionSelected: 41460,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8560,
        gamemode: 2,
        optionSelected: 42797,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8139,
        gamemode: 7,
        optionSelected: 40694,
        deckID: 11110
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8561,
        gamemode: 2,
        optionSelected: 42804,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8293,
        gamemode: 1,
        optionSelected: 41462,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8562,
        gamemode: 2,
        optionSelected: 42809,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8082,
        gamemode: 1,
        optionSelected: 40406,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8083,
        gamemode: 2,
        optionSelected: 40415,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8563,
        gamemode: 1,
        optionSelected: 42812,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 6769,
        gamemode: 7,
        optionSelected: 33845,
        deckID: 11110,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8083,
        gamemode: 1,
        optionSelected: 40415,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8564,
        gamemode: 2,
        optionSelected: 42820,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8084,
        gamemode: 1,
        optionSelected: 40418,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 6769,
        gamemode: 7,
        optionSelected: 33845,
        deckID: 11110,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8085,
        gamemode: 1,
        optionSelected: 40425,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8565,
        gamemode: 2,
        optionSelected: 42821,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8086,
        gamemode: 1,
        optionSelected: 40428,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8293,
        gamemode: 2,
        optionSelected: 41462,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8087,
        gamemode: 1,
        optionSelected: 40434,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8409,
        gamemode: 7,
        optionSelected: 42042,
        deckID: 11110,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8088,
        gamemode: 1,
        optionSelected: 40437,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8089,
        gamemode: 1,
        optionSelected: 40441,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8294,
        gamemode: 1,
        optionSelected: 41469,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 1,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8409,
        gamemode: 7,
        optionSelected: 42042,
        deckID: 11110,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 1,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8566,
        gamemode: 2,
        optionSelected: 42829,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8567,
        gamemode: 2,
        optionSelected: 42831,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8569,
        gamemode: 2,
        optionSelected: 42842,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 1,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8570,
        gamemode: 2,
        optionSelected: 42847,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 1,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8294,
        gamemode: 2,
        optionSelected: 41469,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8571,
        gamemode: 2,
        optionSelected: 42853,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8568,
        gamemode: 2,
        optionSelected: 42837,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 2,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8139,
        gamemode: 7,
        optionSelected: 40694,
        deckID: 11110,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 1,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8572,
        gamemode: 2,
        optionSelected: 42857,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42984,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8091,
        gamemode: 1,
        optionSelected: 40451,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8573,
        gamemode: 2,
        optionSelected: 42862,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8608,
        gamemode: 3,
        optionSelected: 43038,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8092,
        gamemode: 1,
        optionSelected: 40456,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8574,
        gamemode: 2,
        optionSelected: 42869,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8575,
        gamemode: 2,
        optionSelected: 42873,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8093,
        gamemode: 1,
        optionSelected: 40464,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8576,
        gamemode: 2,
        optionSelected: 42877,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8578,
        gamemode: 2,
        optionSelected: 42889,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8295,
        gamemode: 2,
        optionSelected: 41474,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8577,
        gamemode: 2,
        optionSelected: 42882,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8608,
        gamemode: 3,
        optionSelected: 43038,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8579,
        gamemode: 2,
        optionSelected: 42891,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8580,
        gamemode: 2,
        optionSelected: 42896,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8581,
        gamemode: 2,
        optionSelected: 42905,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8295,
        gamemode: 1,
        optionSelected: 41474,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8582,
        gamemode: 2,
        optionSelected: 42909,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8583,
        gamemode: 2,
        optionSelected: 42914,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8608,
        gamemode: 3,
        optionSelected: 43038,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8584,
        gamemode: 2,
        optionSelected: 42917,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8082,
        gamemode: 2,
        optionSelected: 40406,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8083,
        gamemode: 2,
        optionSelected: 40415,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8296,
        gamemode: 2,
        optionSelected: 41477,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8084,
        gamemode: 2,
        optionSelected: 40418,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8085,
        gamemode: 2,
        optionSelected: 40425,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8639,
        gamemode: 3,
        optionSelected: 43194,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8086,
        gamemode: 2,
        optionSelected: 40428,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8087,
        gamemode: 2,
        optionSelected: 40434,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8296,
        gamemode: 1,
        optionSelected: 41477,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8508,
        gamemode: 3,
        optionSelected: 42539,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8086,
        gamemode: 1,
        optionSelected: 40428,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8087,
        gamemode: 1,
        optionSelected: 40434,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8088,
        gamemode: 1,
        optionSelected: 40437,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8088,
        gamemode: 2,
        optionSelected: 40437,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8088,
        gamemode: 2,
        optionSelected: 40437,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8088,
        gamemode: 1,
        optionSelected: 40437,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8297,
        gamemode: 2,
        optionSelected: 41484,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8510,
        gamemode: 3,
        optionSelected: 42550,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8089,
        gamemode: 2,
        optionSelected: 40441,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8089,
        gamemode: 1,
        optionSelected: 40441,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8297,
        gamemode: 1,
        optionSelected: 41484,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8335,
        gamemode: 3,
        optionSelected: 41675,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 2,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8090,
        gamemode: 1,
        optionSelected: 40448,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8301,
        gamemode: 2,
        optionSelected: 41501,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8091,
        gamemode: 1,
        optionSelected: 40451,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8091,
        gamemode: 2,
        optionSelected: 40451,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8092,
        gamemode: 2,
        optionSelected: 40456,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8352,
        gamemode: 3,
        optionSelected: 41759,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8092,
        gamemode: 1,
        optionSelected: 40456,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8093,
        gamemode: 2,
        optionSelected: 40464,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8301,
        gamemode: 1,
        optionSelected: 41501,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8093,
        gamemode: 1,
        optionSelected: 40464,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8365,
        gamemode: 3,
        optionSelected: 41824,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8302,
        gamemode: 1,
        optionSelected: 41508,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8382,
        gamemode: 3,
        optionSelected: 41909,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8302,
        gamemode: 2,
        optionSelected: 41508,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    },
    {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8303,
        gamemode: 1,
        optionSelected: 41511,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8303,
        gamemode: 2,
        optionSelected: 41511,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8304,
        gamemode: 1,
        optionSelected: 41516,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8304,
        gamemode: 2,
        optionSelected: 41516,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8305,
        gamemode: 1,
        optionSelected: 41522,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8305,
        gamemode: 2,
        optionSelected: 41522,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8306,
        gamemode: 1,
        optionSelected: 41530,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8306,
        gamemode: 2,
        optionSelected: 41530,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8306,
        gamemode: 2,
        optionSelected: 41530,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8306,
        gamemode: 1,
        optionSelected: 41530,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8306,
        gamemode: 2,
        optionSelected: 41530,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8306,
        gamemode: 1,
        optionSelected: 41530,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8314,
        gamemode: 1,
        optionSelected: 41569,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8314,
        gamemode: 2,
        optionSelected: 41569,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8315,
        gamemode: 1,
        optionSelected: 41572,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8315,
        gamemode: 2,
        optionSelected: 41572,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8316,
        gamemode: 1,
        optionSelected: 41579,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8316,
        gamemode: 2,
        optionSelected: 41579,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8317,
        gamemode: 1,
        optionSelected: 41583,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8317,
        gamemode: 2,
        optionSelected: 41583,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8318,
        gamemode: 1,
        optionSelected: 41590,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8318,
        gamemode: 2,
        optionSelected: 41590,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8319,
        gamemode: 1,
        optionSelected: 41595,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8319,
        gamemode: 2,
        optionSelected: 41595,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8320,
        gamemode: 1,
        optionSelected: 41600,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8320,
        gamemode: 2,
        optionSelected: 41600,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8321,
        gamemode: 1,
        optionSelected: 41603,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8321,
        gamemode: 2,
        optionSelected: 41603,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8322,
        gamemode: 1,
        optionSelected: 41607,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8322,
        gamemode: 2,
        optionSelected: 41607,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8322,
        gamemode: 1,
        optionSelected: 41607,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8322,
        gamemode: 2,
        optionSelected: 41607,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8322,
        gamemode: 1,
        optionSelected: 41607,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8322,
        gamemode: 2,
        optionSelected: 41607,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8323,
        gamemode: 2,
        optionSelected: 41614,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8323,
        gamemode: 1,
        optionSelected: 41614,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8324,
        gamemode: 1,
        optionSelected: 41617,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8324,
        gamemode: 2,
        optionSelected: 41617,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8325,
        gamemode: 1,
        optionSelected: 41624,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8325,
        gamemode: 2,
        optionSelected: 41624,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8325,
        gamemode: 1,
        optionSelected: 41623,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8325,
        gamemode: 2,
        optionSelected: 41623,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8326,
        gamemode: 1,
        optionSelected: 41628,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8326,
        gamemode: 2,
        optionSelected: 41628,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8327,
        gamemode: 1,
        optionSelected: 41631,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8327,
        gamemode: 2,
        optionSelected: 41631,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8328,
        gamemode: 1,
        optionSelected: 41636,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8328,
        gamemode: 2,
        optionSelected: 41636,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    },{
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8329,
        gamemode: 1,
        optionSelected: 41641,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8329,
        gamemode: 2,
        optionSelected: 41641,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8094,
        gamemode: 2,
        optionSelected: 40470,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8094,
        gamemode: 1,
        optionSelected: 40470,
        deckID: 0,
        token: "00D8Z000001rohW!AQEAQAAOZoObN4NfhcpGfHMeUwpxovur6BbZeiRMnsqUeYip5Fw5SAWA.FEoF1O7T.mrEAjGaRka1jY4i4p5HOlaQX8YaSA4"
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }, {
        mcid: "00863273",
        key: "04EF84044381C77074867B5E18F1BD6CEEA0E7F4F0FE5F8CA612F6C7517E0153",
        questionID: 8597,
        gamemode: 3,
        optionSelected: 42985,
        deckID: 20478,
        tracking: {
            pathname: "/questionScreen",
            pagevia: "SASP browser App",
            action: "answer question",
            os: "Mac OS 10.15.7",
            ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36",
            appid: "org.auanet.auau.sasp",
            appversion: "1.18.013"
        }
    }
]

// ! don't LIKE this 1